var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTieAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3646 3.38849L12.5548 2.16966C12.2189 1.94345 11.7813 1.94345 11.4454 2.16966L9.63558 3.38849C9.26036 3.64118 9.09899 4.1163 9.24159 4.54847L9.77214 6.15633C9.90825 6.56883 10.2904 6.84707 10.7209 6.84707H13.2793C13.7098 6.84707 14.0919 6.56883 14.228 6.15633L14.7586 4.54847C14.9012 4.1163 14.7398 3.64118 14.3646 3.38849Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75272 8.16553L9.01067 17.2881C8.94789 18.0599 9.16376 18.8285 9.61736 19.4481L11.1769 21.5784C11.5884 22.1405 12.4116 22.1405 12.8231 21.5784L14.3826 19.4481C14.8362 18.8285 15.0521 18.0599 14.9893 17.2881L14.2473 8.16553C13.947 8.29301 13.6192 8.36242 13.2792 8.36242H10.7208C10.3808 8.36242 10.053 8.29301 9.75272 8.16553Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTieAlt);
export default __webpack_public_path__ + "static/media/tie-alt.635758a4e1e4dc2ba5be37d2b44b9f27.svg";
export { ForwardRef as ReactComponent };